import { render } from "./Co2EmissionsGraph.vue?vue&type=template&id=2c634f74&scoped=true"
import script from "./Co2EmissionsGraph.vue?vue&type=script&lang=js"
export * from "./Co2EmissionsGraph.vue?vue&type=script&lang=js"

import "./Co2EmissionsGraph.vue?vue&type=style&index=0&id=2c634f74&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c634f74"]])

export default __exports__